<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">收支数据 [{{departmentName}}{{dateStr}}]</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding: 5px;">

        <el-table class="table" size="mini" ref="table" :data="tableData" :height="400" border>

          <el-table-column prop="departmentInOutName" label="收支项目" fixed width="150"></el-table-column>
          <el-table-column prop="total" label="金额"></el-table-column>

        </el-table>

      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      departmentInOutDataId:'',
      departmentName:'',
      dateStr:'',

      tableData:[],
      listDepartmentTakeInDataItem:['a','b'],

    }
  },
  methods: {
    init(row){

      this.departmentName = row.departmentName;
      this.dateStr = row.dateStr;
      this.departmentInOutDataId=row.id;

      this.getList();
    },

    closeSelf() {
      this.$emit("closeInfo");
    },


    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOutData/DataInfo',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          departmentInOutDataId:this.departmentInOutDataId,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.list;

          this.$nextTick(()=>{
            this.$refs.table.doLayout();
          })


        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },




  }
}
</script>

